import { Dialog, DialogContent } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

type HideColumnsV2DialogProps = {
  isOpen: boolean;
  children: React.ReactNode;
};

const useStyles = makeStyles()(() => ({
  contentContainer: {
    padding: '0px',
  },
}));

const HideColumnsV2Dialog = ({ isOpen, children }: HideColumnsV2DialogProps) => {
  const { classes } = useStyles();

  return (
    <Dialog open={isOpen} fullScreen keepMounted>
      <DialogContent className={classes.contentContainer}>{children}</DialogContent>
    </Dialog>
  );
};

export default HideColumnsV2Dialog;
